"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRAVERSE_FRONTEND_ROLES = void 0;
var TRAVERSE_FRONTEND_ROLES;
(function (TRAVERSE_FRONTEND_ROLES) {
    TRAVERSE_FRONTEND_ROLES["USER"] = "user";
})(TRAVERSE_FRONTEND_ROLES = exports.TRAVERSE_FRONTEND_ROLES || (exports.TRAVERSE_FRONTEND_ROLES = {}));
//# sourceMappingURL=traverse-frontend.roles.js.map